import React from 'react';
import Exception from '../../components/Exception'

class NotFound extends React.Component {

    render() {
        return (
            <Exception type="403" />
        )
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/page/pages/403.jsx